import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'usuariosContrato',
})
export class UsuariosContratoPipe implements PipeTransform {

  transform(items: any[], usuariosContrato: any) {

    if (items) {

      if (usuariosContrato && usuariosContrato.length > 0) {
        items = items.filter((item) => usuariosContrato.includes(item.id));
      }

      return items;

    }

  }

}



// WEBPACK FOOTER //
// ./src/pipes/solicitudes/usuarios-contrato.ts